import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TSmsFromNumber } from '@shared/models';

@Injectable({
    providedIn: 'root'
})
export class SmsFromNumbersService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getNullable(): TSmsFromNumber {
        const smsFromNumber: TSmsFromNumber = {
            fromNumber: '',
            numAccounts: 0,
            uid: ''
        };
        return smsFromNumber;
    }

    public getObservable(): Observable<TSmsFromNumber[]> {
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TSmsFromNumber[]>;
        return observable;
    }

    public getByUid(uid: string): Promise<TSmsFromNumber> {
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        return this.firestoreService.getByUid(path, uid) as Promise<TSmsFromNumber>;
    }

    public getAll(): Promise<TSmsFromNumber[]> {
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        return this.firestoreService.getAll(path) as Promise<TSmsFromNumber[]>;
    }

    public add(item: TSmsFromNumber) {
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        return this.firestoreService.add(path, item);
    }

    public set(item: TSmsFromNumber, uid: string) {
        item.uid = uid;
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        return this.firestoreService.set(path, item);
    }

    public update(country: TSmsFromNumber): Promise<TSmsFromNumber> {
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        return this.firestoreService.update(path, country) as Promise<TSmsFromNumber>;
    }

    public delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getSmsFromNumbersPath();
        return this.firestoreService.delete(path, uid);
    }

    public sortByUsage(availableNumbers: TSmsFromNumber[]): TSmsFromNumber[] {
        const sorted = availableNumbers.sort((a, b) => (a.numAccounts - b.numAccounts));

        return sorted;
    }

    public sort(availableNumbers: TSmsFromNumber[]): TSmsFromNumber[] {
        const sorted = availableNumbers.sort((a, b) => ((a.fromNumber > b.fromNumber) ? 1 : -1));

        return sorted;
    }

    public async getLeastUsedNumber(): Promise<TSmsFromNumber> {
        const availableNumbers: TSmsFromNumber[] = await this.getAll();
        const sorted = this.sortByUsage(availableNumbers);
        const leastUsed = sorted[0];
        // const mostUsed = sorted[sorted.length -1];

        return leastUsed;
    }
}
